import React from 'react';
import { useState, useEffect, useContext } from "react";
import Axios from "axios";
import { Table } from 'react-bootstrap';
import LoadingTable from './LoadingTable';
import { thai_date, handleResizeDisplay, checkGroupsUser, getlocalStorage, combineDuplicateUnits, buildListUrl } from '../function/functionALL';
import ModalPagination from './ModalPagination';
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import { FaFileExcel, } from "react-icons/fa";
import { YearContext } from './usecontext/YearContext';
import Swal from "sweetalert2";
import CheckNoContent from './CheckNoContent';

const RANKING_PAGE_SIZE = 10;

const TableRankings = ({ unitname }) => {
    console.log('unitname', unitname)
    const [selectedTableReport, setSelectedTableReport] = useState(1);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole
    const [isStacked, setIsStacked] = useState(false);
    const DateTime = new Date()
    const [Ranking1, setRanking1] = useState([]);
    const [Ranking2, setRanking2] = useState([]);
    const [countRanking1, setCountRanking1] = useState(0);
    const [countRanking2, setCountRanking2] = useState(0);
    const [pageNumber1, setPageNumber1] = useState(1);
    const [pageNumber2, setPageNumber2] = useState(1);
    const handleTableRound1 = (tableNumber) => {
        setSelectedTableReport(tableNumber);
    };
    const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
    const { yearcurrent } = useContext(YearContext);
    useEffect(() => {
        handleResizeDisplay(setIsStacked);
        setPageNumber1(1);
        setPageNumber2(1);

        if (selectedTableReport === 1) {
            GetRanking1unit(1);
        } else {
            GetRanking2unit(1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTableReport, unitname, yearcurrent]);

    const GetRanking1unit = async (page) => {
        try {
            setloadingTable(true)
            const url = buildListUrl(process.env.REACT_APP_API_RANKING, {
                pageNumber: page,
                limit: RANKING_PAGE_SIZE,
                extra: { unit_name: unitname, budget_year: yearcurrent, round: 1 },
            });
            const response = await Axios.get(url, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            setRanking1(response.data.results || [])
            setCountRanking1(response.data.count || 0);
            setloadingTable(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetRanking2unit = async (page) => {
        try {
            setloadingTable(true)
            const url = buildListUrl(process.env.REACT_APP_API_RANKING, {
                pageNumber: page,
                limit: RANKING_PAGE_SIZE,
                extra: { unit_name: unitname, budget_year: yearcurrent, round: 2 },
            });
            const response = await Axios.get(url, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            setRanking2(response.data.results || [])
            setCountRanking2(response.data.count || 0);
            setloadingTable(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const pageNumber = selectedTableReport === 1 ? pageNumber1 : pageNumber2;
    const AmountPage = Math.ceil((selectedTableReport === 1 ? countRanking1 : countRanking2) / RANKING_PAGE_SIZE);

    const handleRankingPageChange = (newPageNumber) => {
        if (selectedTableReport === 1) {
            setPageNumber1(newPageNumber);
            GetRanking1unit(newPageNumber);
        } else {
            setPageNumber2(newPageNumber);
            GetRanking2unit(newPageNumber);
        }
    };


    // Example exportToExcel function
    const exportToExcel = () => {
        const fileName = `สรุปผลการทดสอบสมรรถภาพทางกาย ${yearcurrent + 543} ${selectedTableReport === 1 ? "วงรอบ 1" : "วงรอบ 2"}.xlsx`;

        const ws = XLSX.utils.json_to_sheet(
            TableRanking.map((Data) => ({
                "หน่วย": Data.unit,
                "ทดสอบครบทั้ง 3 ประเภท (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations,
                "ทดสอบ 1-2 ประเภท (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations,
                "ไม่เข้ารับการทดสอบ (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason,
                "รวม (ภาคพื้น)":
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations +
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations +
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason,

                "ทดสอบครบทั้ง 3 ประเภท (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations,
                "ทดสอบ 1-2 ประเภท (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations,
                "ไม่เข้ารับการทดสอบ (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason,
                "รวม (ภาคอากาศ)":
                    Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations +
                    Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations +
                    Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason,
                "ผ่านเกณฑ์ (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150,
                "คิดเป็นร้อยละ (ภาคพื้น)":
                    ((Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) /
                        (Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 1) * 100).toFixed(2),
                "ผ่านเกณฑ์ (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210,
                "คิดเป็นร้อยละ (ภาคอากาศ)":
                    ((Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0) /
                        (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 1) * 100).toFixed(2),
                "รวม (ผ่านเกณฑ์)":
                    (Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) +
                    (Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0),
                "คิดเป็นร้อยละ (รวม)":
                    (((Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) +
                        (Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0)) /
                        ((Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 0) +
                            (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 0) || 1) * 100).toFixed(2),
            }))
        );

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "สรุปผลการทดสอบสมรรถภาพทางกาย");

        // Trigger file download
        XLSX.writeFile(wb, fileName);
    };

    const TableRanking = selectedTableReport === 1 ? Ranking1 : Ranking2

    return (
        <div className="p-2 pb-0 pb-1 ">
            <div className="card col-sm-12 col-xs-12 " style={{ backgroundColor: "rgb(247, 247, 247, 0.68)" }}>
                <div className="card-body rounded pt-3">
                    <div className="row pt-3 pt-md-2" >
                        <div className="col-12 col-md-12 col-lg-10 card-title fw-bold text-center text-md-start p-1 ps-md-2 d-md-flex justify-content-between" style={{ color: "#000000" }}>
                            <span className="fw-bold col-12 col-md-6 col-lg-6 justify-content-end" style={{ color: "#000000", fontSize: "16px" }}>ลำดับผลคะแนนการทดสอบร่างกายสถานีวิ่งระดับหน่วย<span>|  ณ {thai_date(DateTime, "shortdate")}</span>
                            </span>

                        </div>
                        <div>

                        </div>
                    </div>
                    {/* ปุ่มสำหรับสลับตาราง */}
                    <div className=" justify-content-center justify-content-md-end d-flex pb-2 ">
                        <div className="col-12 row d-flex justify-content-center  ">
                            <div className="col-4 "></div>
                            <div className="col-12 col-md-4  "> <p className="text-center  fw-bold " style={{ fontSize: "14px" }}>{selectedTableReport === 1 ? "วงรอบ 1" : "วงรอบ 2"}</p></div>

                            <div className="col-12 col-md-4 text-md-end text-center  ">
                                <div className="btn-group col-lg-7 col-12" role="group" aria-label="Basic example">
                                    <button type="button" className="btn btn-outline-secondary" style={{ fontSize: "12px", background: selectedTableReport === 1 ? "#666699" : "none", borderWidth: "1px", color: selectedTableReport === 1 ? "white" : "#666699" }} onClick={() => handleTableRound1(1)}>วงรอบ 1 </button>
                                    <button type="button" className="btn btn-outline-secondary" style={{ fontSize: "12px", background: selectedTableReport === 2 ? "#666699" : "none", borderWidth: "1px", color: selectedTableReport === 2 ? "white" : "#666699" }} onClick={() => handleTableRound1(2)}>วงรอบ 2 </button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 p-0 m-0   ">

                        <div className="card-body p-0">
                            <div className="overflow-auto ">
                                <div style={{ height: "auto" }}>
                                    {loadingTable ? (
                                        <LoadingTable />
                                    ) : (
                                        Array.isArray(TableRanking) && TableRanking.length > 0 ? (
                                            <div className="col-12 p-0 m-0 pt-3">
                                                <div className="card-body p-0">
                                                    <div className="overflow-auto">
                                                        <div style={{ height: "auto" }}>
                                                            <Table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover table-striped'}>
                                                                <thead>
                                                                    <tr style={{ zIndex: "1" }}>
                                                                        <th scope="col" style={{ fontSize: "14px", textAlign: "center", width: "8%", minWidth: "100px", backgroundColor: "#666699", height: "60px", color: "white", verticalAlign: "middle" }}>ลำดับ</th>
                                                                        <th scope="col" style={{ fontSize: "14px", textAlign: "center", width: "8%", minWidth: "100px", backgroundColor: "#666699", height: "60px", color: "white", verticalAlign: "middle" }}>ชื่อ-นามสกุล</th>
                                                                        <th scope="col" style={{ fontSize: "14px", width: "10%", minWidth: "150px", textAlign: "center", backgroundColor: "#8181B8", color: "white", verticalAlign: "middle" }}>ระยะเวลาที่ทำได้</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}>
                                                                    {TableRanking.map((Data, i) => {
                                                                        const rank = (pageNumber - 1) * RANKING_PAGE_SIZE + i + 1;
                                                                        return (
                                                                        <tr className="raw" key={i}>
                                                                            <td className="text-center" style={{ fontSize: "14px", backgroundColor: "#d0d9ff", verticalAlign: "middle" }} data-label="ลำดับ">{rank === 1 ? `1 🏆` : rank === 2 ? `2 🥈` : rank === 3 ? `3 🥉` : rank}</td>
                                                                            <td className="text-center" style={{ fontSize: "14px", backgroundColor: "#d0d9ff", verticalAlign: "middle" }} data-label="ชื่อ-นามสกุล">{Data.test_result}</td>
                                                                            <td className="text-center" style={{ fontSize: "14px", verticalAlign: "middle" }} data-label="ระยะเวลาที่ทำได้">{Data.run_time}  </td>

                                                                        </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                            <ModalPagination
                                                                pageNumber={pageNumber}
                                                                AmountPage={AmountPage}
                                                                handlePageChange={handleRankingPageChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <CheckNoContent />
                                        )
                                    )}

                                </div>
                            </div>


                        </div>

                    </div>

                </div>



            </div>
        </div>
    );
};

export default TableRankings;
